export default {
    pickerView:{
        minHeight:325,
        justifyContent: "flex-start"
    }
  };
  